import React from "react";
import Navbar from "../Components/Navbar";
import { Link, useNavigate } from "react-router-dom";
import { sendPostRequest, useGetRequest } from "../Client";
import { useState } from "react";
import Cookies from "js-cookie";

function Login() {
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requestBody = {
      email: e.target.email.value,
      password: e.target.password.value,
      customerID: process.env.REACT_APP_ACCOUNT_ID,
    };

    const res = await sendPostRequest("login", requestBody)
      .then((res) => {
        Cookies.set("token", res.token, { expires: 7, secure: true });
        window.location.href = "/dashboard";
      })
      .catch((res) => {
        setError("Incorrect login details");
      });
  };

  return (
    <>
      <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8 mt-20">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <img
            className="mx-auto h-20 w-auto"
            src={process.env.REACT_APP_LOGO}
            alt={process.env.REACT_APP_COMPANY}
          />
          <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
            Sign in to your account
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          {error ? (
            <div className="flex justify-center px-6 py-2 text-red-500">
              {error}
            </div>
          ) : null}

          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Email address
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label
                  htmlFor="password"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Password
                </label>
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              {/* <Link to="/dashboard"> */}
              <button
                type="submit"
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Sign in
              </button>
              {/* </Link> */}
            </div>
          </form>
        </div>

        {process.env.REACT_APP_LOGO_SECONDARY && (
          <img
            className="mx-auto h-10 w-auto mt-10"
            src={process.env.REACT_APP_LOGO_SECONDARY}
            alt={process.env.REACT_APP_COMPANY}
          />
        )}
      </div>
    </>
  );
}

export default Login;
